export enum RedirectRoutes {
  ERROR = '/error',
  DASHBOARD = '/admin',
}
